import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
export const ValueChangeWatcher = ({ fieldName, value, skipValidation, onChange, onError, }) => {
    const { control, setValue, clearErrors, getFieldState } = useFormContext();
    const currentEmailValue = useWatch({ control, name: fieldName });
    const { error } = getFieldState(fieldName);
    useEffect(() => {
        currentEmailValue !== value && setValue(fieldName, value, { shouldValidate: true });
    }, [value]);
    useEffect(() => {
        onChange && onChange(currentEmailValue);
    }, [currentEmailValue]);
    useEffect(() => {
        (error === null || error === void 0 ? void 0 : error.message) && (onError === null || onError === void 0 ? void 0 : onError(error.message));
    }, [error]);
    useEffect(() => {
        if (skipValidation) {
            clearErrors(fieldName);
        }
        else {
            setValue(fieldName, currentEmailValue, { shouldValidate: true });
        }
    }, [skipValidation]);
    return null;
};
